import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import store from '@core/store/redux';
import profileStore, { SearchParamsSelector } from '@modules/authentication/profileStore';

export const useGoToCMS = () => {
  const navigate = useNavigate();
  const _search = useSelector(SearchParamsSelector);

  const goToCMS = () => {
    navigate({
      pathname: '/',
      search: _search || '',
    });
    if (_search) {
      store.dispatch(profileStore.actions.updateSearchParams(''));
    }
  };

  return goToCMS;
};
